import { sdkRequest } from '@eventbrite/http';
import { deepKeysToCamel } from '@eventbrite/transformation-utils';
import isEmpty from 'lodash/isEmpty';
import {
    FinancialInformationAPIResponse,
    FinancialInformationFormatted,
} from './types';

export const getFinancialInformation = (
    orgId: string | undefined,
): Promise<FinancialInformationFormatted | null> => {
    if (!orgId) {
        return Promise.resolve(null);
    }
    return sdkRequest(`/api/v3/organizations/${orgId}/financial_information/`)
        .then((data: FinancialInformationAPIResponse) =>
            isEmpty(data) ? null : deepKeysToCamel(data),
        )
        .catch(() => null);
};
